import { useContext } from 'react';

import { XYChartOverlayRefContext } from '../context/XYChartOverlayRefContext.js';

export const useXYChartOverlayRef = () => {
  const context = useContext(XYChartOverlayRefContext);

  if (!context) {
    throw new Error(
      '"useXYChartOverlayRef" needs to be used under "XYChartOverlayRefContext"',
    );
  }

  return context;
};
